module.exports = __webpack_public_path__ + "assets/9827e3590e3e025af213a1898d8d2b81.wav";